export default "__VITE_ASSET__BqWE$Thj__"